export const ORIGINS = {
  AOP: "Appellation d'Origine Protégée",
  BBC: "Bleu Blanc Coeur",
  BIO: "Bio",
  FM: "Fait Maison",
  IGP: "Indication Géographique Protégée",
  MSC: "Msc",
  LBR: "Label Rouge",
  POF: "Le Porc Français",
  SGE: "Produit Décongelé",
  VBF: "Viande Bovine Française",
  VOF: "Viande Volaille Française",
};

export const PRODUCT_TYPES = {
  STARTER: "ENT",
  MAIN: "PLA",
  DESSERT: "DES",
  SNACKING: "SNA",
  SALAD: "SAL",
  GOUR: "GOU",
  CHEESE: "FRO",
  FRUIT: "FRU",
  EGGBAR: "EGG",
  BREAD: "PAI",
  VIEN: "VIE",
  GAT: "GAT",
  BOC: "BOC",
  BOI: "BOI",
};

export const PRODUCT_TYPES_NAMES = {
  [PRODUCT_TYPES.STARTER]: "Entrée",
  [PRODUCT_TYPES.MAIN]: "Plat",
  [PRODUCT_TYPES.DESSERT]: "Dessert",
  [PRODUCT_TYPES.CHEESE]: "Fromages",
  [PRODUCT_TYPES.SNACKING]: "Snacking",
  [PRODUCT_TYPES.SALAD]: "Bar à Salade",
  [PRODUCT_TYPES.GOUR]: "Gourmandise",
  [PRODUCT_TYPES.FRUIT]: "Fruit",
  [PRODUCT_TYPES.EGGBAR]: "Oeuf",
  [PRODUCT_TYPES.BREAD]: "Pain",
  [PRODUCT_TYPES.VIEN]: "Viennoiserie",
  [PRODUCT_TYPES.GAT]: "Gateaux",
  [PRODUCT_TYPES.BOC]: "Boissons chaude",
  [PRODUCT_TYPES.BOI]: "Boisson",
};
